import { AgChartOptions } from "@ag-grid-community/core";
import { IRegistryDataRow } from "../../../models/RegistryData";
import { IRegistryDataColumn } from "../../../models/RegistryDataColumn";

export const getEthnicityChartOptions = (
  rows: IRegistryDataRow[],
  colDef: IRegistryDataColumn
): AgChartOptions => {
  const chartData = getEthnicityChartData(rows, colDef);

  const chartOptions: AgChartOptions = {
    title: {
      text: "Ethnicity",
    },
    subtitle: {
      text: "Individual can have multiple ethnicities",
    },
    background: {
      visible: false,
    },
    theme: {
      baseTheme: "ag-vivid",
      palette: {
        fills: ["#1F94A3"],
        strokes: ["#2B7781"],
      },
    },
    data: chartData,
    series: [
      {
        type: "column",
        yKey: "count",
        xKey: "category",
        showInLegend: false,
        highlightStyle: {
          item: {
            fill: "#1F94A3",
            strokeWidth: 0,
          },
        },
      },
    ],
    legend: {
      enabled: false,
    },
    axes: [
      {
        type: "category",
        position: "bottom",
        title: { text: "Ethnicity" },
        label: {
          fontSize: 10,
          rotation: 10
        }
      },
      {
        type: "number",
        position: "left",
        title: { text: "Number of individuals" },
      },
    ],
  };

  return chartOptions;
};

export const getEthnicityChartData = (
  rows: IRegistryDataRow[],
  colDef: IRegistryDataColumn
) => {
  const chartDataCounts = {};

  if (colDef.options) {
    Object.entries(colDef.options).forEach(([key, option]) => {
      const lookupKey = option.lookup_key as string;
      chartDataCounts[lookupKey] = {
        category: option.label,
        count: 0,
      };
    });
  }

  rows.forEach((row) => {
    Object.entries(chartDataCounts).forEach(([lookupKey, option]) => {
      if (row && row.hasOwnProperty(lookupKey) && row[lookupKey] === 1) {
        chartDataCounts[lookupKey].count += 1;
      }
    });
  });

  const chartData = Object.values(chartDataCounts);

  return chartData;
};
